<template>
  <path
    d="M2 8a6 6 0 1 1 12 0A6 6 0 0 1 2 8zm6-3a.5.5 0 0 0-.5.5v2h-2a.5.5 0 0 0 0 1h2v2a.5.5 0 0 0 1 0v-2h2a.5.5 0 0 0 0-1h-2v-2A.5.5 0 0 0 8 5z"
  />
</template>
